import { DATA_BASE_URL } from '@lib/constants';
import Icon from '@components/common/Icon';

const certificates = [
  {
    id: 1,
    title: 'ABRSM Violin Performance Grade 5',
    date: 'December 2021',
    file: `${DATA_BASE_URL}/data/music/certificates/violin_performance_grade_5_dec2021.pdf`,
    description: 'I passed ABRSM Violin Performance examination at Grade 5 level',
  },
  {
    id: 2,
    title: 'ABRSM Music Theory Grade 5',
    date: '2023',
    file: `${DATA_BASE_URL}/data/music/certificates/music_theory_grade_5.pdf`,
    description: 'I achieved proficiency in music theory Grade 5 examination',
  },
  {
    id: 3,
    title: 'ABRSM Certificates',
    date: '2021-2023',
    file: `${DATA_BASE_URL}/data/music/certificates/abrsm_certificates.pdf`,
    description: 'My multiple ABRSM certifications across grades and disciplines',
  },
];

const CertificatesSection = () => {
  return (
    <section
      className="py-20 px-4 sm:px-6 lg:px-8"
      style={{
        backgroundColor: 'var(--color-body-bg)',
      }}
    >
      <div className="container mx-auto max-w-7xl">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <div className="flex items-center justify-center gap-3 mb-4">
            <Icon name="academics" size="xl" style={{ color: 'var(--color-accent-6)' }} />
            <h2
              className="text-4xl sm:text-5xl font-heading font-bold tracking-tight"
              style={{ color: 'var(--color-heading)' }}
            >
              ABRSM Certifications
            </h2>
          </div>
          <p
            className="text-lg max-w-3xl mx-auto"
            style={{ color: 'var(--color-subtle)' }}
          >
            Recognized certifications from the Associated Board of the Royal Schools of Music
          </p>
        </div>

        {/* Certificates - Horizontal Scroll on Mobile */}
        <div className="md:grid md:grid-cols-3 md:gap-8 flex md:flex-none overflow-x-auto gap-6 snap-x snap-mandatory scrollbar-hide pb-4 -mx-4 px-4 sm:mx-0 sm:px-0">
          {certificates.map((cert) => (
            <a
              key={cert.id}
              href={cert.file}
              target="_blank"
              rel="noopener noreferrer"
              className="group rounded-2xl overflow-hidden shadow-card transition-all duration-300 hover:shadow-card-hover hover:scale-105 flex-shrink-0 w-[85vw] sm:w-[60vw] md:w-auto snap-center"
              style={{
                backgroundColor: 'var(--color-card-bg)',
                borderColor: 'var(--color-card-border)',
                borderWidth: '1px',
                borderStyle: 'solid',
              }}
            >
              {/* Icon Section */}
              <div
                className="h-32 flex items-center justify-center"
                style={{
                  background: `linear-gradient(135deg, var(--color-accent-2), var(--color-accent-1))`,
                }}
              >
                <svg
                  className="w-16 h-16"
                  style={{ color: 'var(--color-accent-7)' }}
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
                </svg>
              </div>

              {/* Certificate Info */}
              <div className="p-6 space-y-3">
                <h3
                  className="text-xl font-semibold"
                  style={{ color: 'var(--color-heading)' }}
                >
                  {cert.title}
                </h3>
                <p
                  className="text-sm"
                  style={{ color: 'var(--color-muted)' }}
                >
                  {cert.description}
                </p>
                <div
                  className="flex items-center justify-between pt-4 border-t"
                  style={{ borderColor: 'var(--color-border-light)' }}
                >
                  <span
                    className="text-sm font-semibold"
                    style={{ color: 'var(--color-subtle)' }}
                  >
                    {cert.date}
                  </span>
                  <svg
                    className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300"
                    style={{ color: 'var(--color-accent-6)' }}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* Download Section */}
        <div
          className="mt-16 p-8 rounded-2xl text-center"
          style={{
            backgroundColor: 'var(--color-theme-2)',
            borderColor: 'var(--color-accent-2)',
            borderWidth: '2px',
            borderStyle: 'dashed',
          }}
        >
          <p
            className="text-lg"
            style={{ color: 'var(--color-subtle)' }}
          >
            Click on any certificate to download or view the full document
          </p>
        </div>
      </div>
    </section>
  );
};

export default CertificatesSection;
